// extracted by mini-css-extract-plugin
module.exports = {"makeModelIntro":"PlpIntro_makeModelIntro__1k_vJ","expanded":"PlpIntro_expanded__eEw6W","copy":"PlpIntro_copy__PSJOu","viewMore":"PlpIntro_viewMore__eo2L_"};